import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const ProductDescription = ({ detailsModal, setDetailsModal }) => {
  const details = detailsModal.details;
  return (
    <div
      style={detailsModal.show ? {} : { display: 'none' }}
      className="details-modal__container"
    >
      <button
        className="bundler-button"
        onClick={() => {
          setDetailsModal({ show: false });
        }}
      >
        <i className="arrow left" /> BACK
      </button>
      {details && (
        <>
          <div className="details-modal">
            <div className="details-modal__name">
              <p>{details.productName}</p>
            </div>
            <div className="details-modal__image-desc">
              <img
                src={details.url_image}
                alt={details.variantName}
                className="xrs-product__image"
                width="100px"
                height="100px"
              />
              <p className="details-modal__desc">
                {ReactHtmlParser(details.description)}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ProductDescription;
